import React from 'react';
import AgencyRegistryForm, { AgencyRegistryFormModel } from '../../../components/agency-registry-form/AgencyRegistryForm';
import { agencyRegistryFormModelToAgency, agencyToAgencyRegistryFormModel } from './mappers';
import { CreateAgencyWizardStepProps } from '../types';

const AgencyRegistryWizardStep: React.FC<CreateAgencyWizardStepProps> = ({
  initialData,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const onInternalSubmit = React.useCallback((formValues: AgencyRegistryFormModel) => {
    const values = agencyRegistryFormModelToAgency(formValues, initialData);

    // TODO: Fix the type in bricks
    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    onSubmit(values, isFormDirty);
  }, [formRef, initialData, onSubmit]);

  return (
    <AgencyRegistryForm
      initialValues={agencyToAgencyRegistryFormModel(initialData)}
      innerRef={formRef}
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AgencyRegistryWizardStep;
